import { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
// import Tables from "../../components/Tables";
import { Col, Row, Button } from "antd";
import styled from "styled-components";
import Title from "../../../components/Title";
import { BranchesOutlined } from "@ant-design/icons";
import { TYPE_GET_DATE } from "../../../../helper/const";
import { exportExcel, getDateChangeTime, sortDataNatcom } from "../../../../helper/helper";
import DashboardPages from "../../../Dashboard/DashboardPages";
import FilterTime from "../../../components/FilterTime";
import _ from "lodash";
import DashboardOverview from "../../components/DashboardOverview";
import { DownloadOutlined } from "@ant-design/icons";


export default function Overview({ handleGetData, tabActive }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));

  const { result = {} } =
    useSelector((state) => state.reducerVmUnitel?.data) || {};
  const { data: vm_unitel = [] } = result;

  const datas = useMemo(() => {
    let quantity_vm_unitel = [];
    let dataRevenue_vm_unitel = [];
    if (!_.isEmpty(vm_unitel)) {
      for (const property in vm_unitel) {
        const itemQuantity = {
          type: "dataMarker",
          time: property,
          top: true,
          position: ["", 0],
          text: {
            content: "0",
          },
        };
        quantity_vm_unitel = [...quantity_vm_unitel, itemQuantity];
        const totalItem = _.last(vm_unitel[property]) || {};

        const item = {
          time: property,
          revenue: Number(totalItem.d_total_fee),
          id: property,
        };
        dataRevenue_vm_unitel = [...dataRevenue_vm_unitel, item];
      }
    }

    const revertDataQuantity_vm_unitel = quantity_vm_unitel.reverse();
    const revertDataRevenue_vm_unitel = dataRevenue_vm_unitel.reverse();
    return {
      vm_unitel: {
        quantity: revertDataQuantity_vm_unitel,
        dataRevenue: revertDataRevenue_vm_unitel,
      },
    };
  }, [vm_unitel]);

  useEffect(() => {
    if (tabActive !== "1") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  let quantityRevenue_vm_unitel = {
    data: sortDataNatcom(datas?.vm_unitel?.dataRevenue || []),
    xField: "time",
    yField: ["revenue", "revenue"],
    annotations: {
      quantity: sortDataNatcom(datas?.vm_unitel?.quantity || []),
    },
  };

  const handleExportExcel = () => {
    exportExcel(vm_unitel, "vm_unitel")
  }

  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2 gap-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
        <div className="d-flex justify-content-end">
          <Button 
            onClick={handleExportExcel} 
            className="d-flex align-items-center"
          >
            <DownloadOutlined /> 
            Export Excel
          </Button>
        </div>
      </div>
      <Container className="panel panel-sortable">
        <Title titleName="Overview">
          <BranchesOutlined />
        </Title>
        <Col span={24}>
          <Col xs={24} lg={24} className="container-item">
          <div className="item-chart">
              {/* <DashboardPages dataDashboard={quantityRevenue} /> */}
              <h4 className="pt-3 pe-3 pb-5">Overview revenue chart VM:</h4>
              <DashboardOverview
                dataDashboard={quantityRevenue_vm_unitel}
                yField={"revenue"}
              />
            </div>
          </Col>
        </Col>
      </Container>
    </>
  );
}

const Container = styled(Row)``;
